import { GetDateFromString } from "../../../../../../shared/scripts/date-functions";
import { SamplesLookup } from "./samples.lookup";

export class Samples {
    Id: number;
    Name: string;
    OrderBy: number;

    constructor(id: number, name: string, ordering: number) {
        this.Id = id;
        this.Name = name;
        this.OrderBy = ordering;
    }
}

export class SamplesEvent {
    AppendixId: number;
    BiospecId: number;
    BiospecDescId: number;
    IsExpected: boolean;

    ReasonNotDone1: number;
    ReasonNotDone2: number;
    ReasonNotDoneId: number;

    SiteNumber: number;
    SamplesStatusId: number;
    StudyId: number;
    SubjectId: string;
    //Visit: number;
    //VisitFullNId: number;
    VisitAbb: number;
    VisitN: number;

    initialize(): void {
        if (this.ReasonNotDone1 && this.ReasonNotDone1 !== 0) {
            this.ReasonNotDoneId = this.ReasonNotDone1;
        } else if (this.ReasonNotDone2 && this.ReasonNotDone2 !== 0) {
            this.ReasonNotDoneId = this.ReasonNotDone2 + 100;
        } else {
            this.ReasonNotDoneId = undefined;
        }
    }
}